/**
 * A global namespace for `mouseleave` event.
 */
const mouseleaveEvent = 'mouseleave';
export default mouseleaveEvent;
